<template>
  <div>
    <v-dialog
      v-model="computedGroomingWinchVisibility"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="methodToggleListView('grooming', 'winch')">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Winch Anchors</v-toolbar-title
          >

          <v-spacer class="hidden-sm-and-down" />
          <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="search"
            placeholder="Filter data"
          ></v-text-field>
          <v-spacer class="hidden-sm-and-down" />
          <v-btn @click="addAnchor = true" color="info">Add Anchor</v-btn>
          <v-menu
            v-if="
              computedAuthProfile === 'admin' ||
                computedAuthProfile === 'maintenance'
            "
            bottom
            left
          >
            <v-btn slot="activator" icon>
              <v-icon>get_app</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click.stop="methodDownloadCSV()">
                <v-list-tile-title>CSV</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>
        <div
          style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
        >
          <v-data-table
            :headers="headers"
            :items="computedGroomingWinchGeoJsonFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            :search="search"
            class="elevation-1"
            :loading="computedGroomingWinchLoading"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'grooming',
                    'winch',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td>{{ props.item.properties.mountain }}</td>
                <td>{{ props.item.properties.zone }}</td>
                <td>{{ props.item.properties.trail_name }}</td>
                <td>{{ props.item.properties.a_number }}</td>
                <td>{{ props.item.properties.loc_descript }}</td>
                <td>{{ props.item.properties.rope_length }}</td>
                <td>{{ props.item.properties.st_time }}</td>
                <td>{{ props.item.properties.fin_time }}</td>
                <td>{{ props.item.properties.overall_anch_cond }}</td>
              </tr>
            </template>

            <!-- Alert when no results found -->
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- ADD Anchor DIALOG -->
    <v-dialog
      v-if="addAnchor"
      v-model="addAnchor"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addAnchor = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
              base64image = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Add Anchor</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            v-if="addAnchor"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Image</td>
                <td>
                  <image-uploader
                    @input="setOutput"
                    :quality="0.8"
                    :autoRotate="attemptAutoRotate"
                    outputFormat="base64"
                    class="fileinput2"
                    :preview="true"
                    accept=".jpg, .jpeg"
                    :key="attemptAutoRotate"
                  ></image-uploader>
                </td>
              </tr>
              <tr>
                <td>EXIF rotate?</td>
                <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Altitude</td>
                <td>
                  <span v-if="!altitude && tracking">Getting altitude...</span>
                  {{ altitude }}
                  <span v-if="altitude">m</span>
                </td>
              </tr>
              <tr>
                <td>Mountain</td>
                <td>
                  <v-select
                    ref="ref_mountain"
                    v-model="form.mountain"
                    :items="opt_mountain"
                  />
                </td>
              </tr>
              <tr>
                <td>Zone</td>
                <td>
                  <v-select
                    ref="ref_zone"
                    v-model="form.zone"
                    :items="computedZone"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Run Name</td>
                <td>
                  <v-autocomplete
                    ref="ref_trail_name"
                    :items="computedTrailName"
                    v-model="form.trail_name"
                  />
                </td>
              </tr>
              <tr>
                <td>Anchor Number</td>
                <td>
                  <v-text-field ref="ref_a_number" v-model="form.a_number" />
                </td>
              </tr>
              <tr>
                <td>Location Description</td>
                <td>
                  <v-text-field
                    ref="ref_loc_descript"
                    v-model="form.loc_descript"
                  />
                </td>
              </tr>
              <tr>
                <td>Cable Length Required</td>
                <td>
                  <v-text-field
                    ref="ref_rope_length"
                    v-model="form.rope_length"
                  />
                </td>
              </tr>
              <tr>
                <td>Start Time</td>
                <td>
                  <v-text-field ref="ref_st_time" v-model="form.st_time" />
                </td>
              </tr>
              <tr>
                <td>Finish Time</td>
                <td>
                  <v-text-field ref="ref_fin_time" v-model="form.fin_time" />
                </td>
              </tr>
              <tr>
                <td>Sign & Light Locations</td>
                <td>
                  <v-text-field ref="ref_s_li_loc" v-model="form.s_li_loc" />
                </td>
              </tr>
              <tr>
                <td>Notes</td>
                <td>
                  <v-textarea ref="ref_notes" v-model="form.notes" />
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddGroomingWinchGeoJson({
                        lat: lat,
                        lng: lng,
                        accuracy: accuracy,
                        altitude: altitude,
                        mountain: form.mountain,
                        zone: form.zone,
                        trail_name: form.trail_name,
                        a_number: form.a_number,
                        loc_descript: form.loc_descript,
                        rope_length: form.rope_length,
                        st_time: form.st_time,
                        fin_time: form.fin_time,
                        s_li_loc: form.s_li_loc,
                        notes: form.notes,
                        base64data: base64image
                      });
                      addAnchor = false;
                      clearWatchLocation();
                      lat = null;
                      lng = null;
                      accuracy = null;
                      altitude = null;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { parse } from "json2csv";

("dataGroomingWinch");
export default {
  data() {
    return {
      opt_mountain: [{ text: "Whistler" }, { text: "Blackcomb" }],
      tracking: false,
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      watchId: null,
      form: {
        mountain: null,
        zone: null,
        trail_name: null,
        a_number: null,
        loc_descript: null,
        rope_length: null,
        st_time: null,
        fin_time: null,
        s_li_loc: null,
        notes: null
      },
      base64image: null,
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      attemptAutoRotate: false,
      addAnchor: false,
      select_mountain_items: ["Both Mountains", "Whistler", "Blackcomb"],
      select_mountain_model: "Both Mountains",
      loading: true,
      search: "",
      rows_per_page: [10, 25, 50, { text: "All", value: -1 }],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Mountain",
          value: "properties.mountain"
        },
        {
          text: "Zone",
          value: "properties.zone"
        },
        {
          text: "Trail Name",
          value: "properties.trail_name"
        },
        {
          text: "Anchor #",
          value: "properties.a_number"
        },
        {
          text: "Description",
          value: "properties.loc_descript"
        },
        {
          text: "Rope Length",
          value: "properties.rope_length"
        },
        {
          text: "Start Time",
          value: "properties.start_time"
        },
        {
          text: "Finish Time",
          value: "properties.fin_time"
        },
        {
          text: "Overall Condition",
          value: "properties.overall_anch_cond"
        }
      ]
    };
  },
  computed: {
    computedTrailName() {
      const trailNames = this.$store.state.mapLayers.grooming.layers.winch
        .geojson.features;
      const trailNamesArr = [];
      trailNames.map(item => {
        trailNamesArr.push(item.properties.trail_name);
      });
      const uniqueTrailNames = Array.from(new Set(trailNamesArr));
      let finalResults = [];
      uniqueTrailNames.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedZone() {
      const zones = this.$store.state.mapLayers.grooming.layers.winch.geojson
        .features;
      const zonesArr = [];
      zones.map(item => {
        zonesArr.push(item.properties.zone);
      });
      const uniqueZones = Array.from(new Set(zonesArr));
      let finalResults = [];
      uniqueZones.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedGroomingWinchGeoJsonFeatures() {
      if (this.$store.state.mapLayers.grooming.layers.winch.geojson.features) {
        return this.$store.state.mapLayers.grooming.layers.winch.geojson
          .features;
      }
      return [];
    },
    computedGroomingWinchVisibility() {
      return this.$store.state.mapLayers.grooming.layers.winch.visibility
        .listView;
    },
    computedGroomingWinchLoading() {
      return this.$store.state.mapLayers.grooming.layers.winch.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodAddGroomingWinchGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [data.lng, data.lat]
            },
            properties: {
              mountain: data.mountain,
              zone: data.zone,
              trail_name: data.trail_name,
              a_number: data.a_number,
              loc_descript: data.loc_descript,
              rope_length: data.rope_length,
              st_time: data.st_time,
              fin_time: data.fin_time,
              s_li_loc: data.s_li_loc,
              notes: this.$refs.ref_notes.value
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddJsonImage", {
          url: "https://api2.alchemymapping.com/vail/whistler/grooming/winch",
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/grooming/winch/image",
          base64data: this.base64image,
          dept: "grooming",
          layer: "winch",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(
          setTimeout(() => {
            this.methodGetGroomingWinchGeoJson();
          }, 250)
        );
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },

    setOutput(file) {
      this.base64image = file;
    },
    // method to get geojson
    methodGetGroomingWinchGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/grooming/winch",
        dept: "grooming",
        layer: "winch",
        token: this.computedAuthToken
      });
    },
    methodDownloadCSV() {
      const fields = [
        {
          label: "Mountain",
          value: "properties.mountain"
        },
        {
          label: "Zone",
          value: "properties.zone"
        },
        {
          label: "Trail Name",
          value: "properties.trail_name"
        },
        {
          label: "Anchor Number",
          value: "properties.a_number"
        },
        {
          label: "Location Description",
          value: "properties.loc_descript"
        },
        {
          label: "Rope Length",
          value: "properties.rope_length"
        },
        {
          label: "Start Time",
          value: "properties.st_time"
        },
        {
          label: "Start Time",
          value: "properties.st_time"
        },
        {
          label: "Finish Time",
          value: "properties.fin_time"
        },
        {
          label: "Inspection Date",
          value: "properties.date_inspect"
        },
        {
          label: "Chain Number",
          value: "properties.num_chain"
        },
        {
          label: "Chain Condition",
          value: "properties.cond_chain"
        },
        {
          label: "Cable Number",
          value: "properties.num_cable"
        },
        {
          label: "Cable Condition",
          value: "properties.cond_cable"
        },
        {
          label: "Master Link Number",
          value: "properties.num_mlink"
        },
        {
          label: "Master Link Condition",
          value: "properties.cond_mlink"
        },
        {
          label: "Shackle Number",
          value: "properties.num_shackle"
        },
        {
          label: "Shackle Condition",
          value: "properties.cond_shackle"
        },
        {
          label: "Hose Number",
          value: "properties.num_hose"
        },
        {
          label: "Hose Condition",
          value: "properties.cond_hose"
        },
        {
          label: "#8 Number",
          value: "properties.num_8"
        },
        {
          label: "#8 Condition",
          value: "properties.cond_8"
        },
        {
          label: "#9 Number",
          value: "properties.num_9"
        },
        {
          label: "#9 Condition",
          value: "properties.cond_9"
        },
        {
          label: "#10 Number",
          value: "properties.num_10"
        },
        {
          label: "#10 Condition",
          value: "properties.cond_10"
        },
        {
          label: "Number Nut",
          value: "properties.num_nut"
        },
        {
          label: "Condition Nut",
          value: "properties.condition_nut"
        },
        {
          label: "Condition Tower",
          value: "properties.cond_tower"
        },
        {
          label: "Condition Tree",
          value: "properties.cond_tree"
        },
        {
          label: "Number Plate 1",
          value: "properties.num_plate1"
        },
        {
          label: "Condition Plate 1",
          value: "properties.cond_plate1"
        },
        {
          label: "Number Plate 0.75",
          value: "properties.num_plate075"
        },
        {
          label: "Condition Plate 0.75",
          value: "properties.cond_plate075"
        },
        {
          label: "Number Plate 0.5",
          value: "properties.num_plate05"
        },
        {
          label: "Condition Plate 0.5",
          value: "properties.cond_plate05"
        },
        {
          label: "Condition Rocklite",
          value: "properties.cond_rocklite"
        },
        {
          label: "Condition Epoxy",
          value: "properties.cond_epoxy"
        },
        {
          label: "Condition Masonry",
          value: "properties.cond_masonry"
        },
        {
          label: "Condition Rock",
          value: "properties.cond_rock"
        },
        {
          label: "Condition Lockblock",
          value: "properties.cond_lockblock"
        },
        {
          label: "Condition Treebase",
          value: "properties.cond_treebase"
        },
        {
          label: "Condition Unserviceable",
          value: "properties.cond_unserviceable"
        },
        {
          label: "Condition Bar",
          value: "properties.cond_bar"
        },
        {
          label: "Number Bar",
          value: "properties.num_bar"
        },
        {
          label: "Condition Hangernut",
          value: "properties.cond_hangernut"
        },
        {
          label: "Number Hangernut",
          value: "properties.num_hangernut"
        },
        {
          label: "Condition Rock",
          value: "properties.cond_hangerrock"
        },
        {
          label: "Condition Rope",
          value: "properties.cond_rope"
        },
        {
          label: "Number Rope",
          value: "properties.num_rope"
        },
        {
          label: "Condition Tree",
          value: "properties.cond_hangertree"
        },
        {
          label: "Number Track Belt",
          value: "properties.num_trackbelt"
        },
        {
          label: "Condition Track Belt",
          value: "properties.cond_trackbelt"
        },
        {
          label: "Number Yellow",
          value: "properties.num_yellow"
        },
        {
          label: "Condition Yellow",
          value: "properties.cond_yellow"
        },
        {
          label: "Number ABS",
          value: "properties.num_ABS"
        },
        {
          label: "Condition ABS",
          value: "properties.cond_ABS"
        },
        {
          label: "Work Required",
          value: "properties.work_required"
        },
        {
          label: "Work Complete",
          value: "properties.work_complete"
        },
        {
          label: "Completed By",
          value: "properties.completed_by"
        },
        {
          label: "Overall Anchor Condition",
          value: "properties.overall_anch_cond"
        },
        {
          label: "Notes",
          value: "properties.notes"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.grooming.layers.winch.geojson.features.sort(
            (a, b) => {
              if (a.properties.a_number < b.properties.a_number) return -1;
              if (a.properties.a_number > b.properties.a_number) return 1;
              return 0;
            }
          ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "grooming_winch_anchors.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.grooming.layers.winch.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetGroomingWinchGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.grooming.layers.winch.geojson": function(newValue) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
